import './index.scss';
import './stylesheet/main.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import { Provider } from 'react-redux';

import HotelContextProvider from './context/HotelContext';
import LanguageContextProvider from './context/LanguageContext';

// Replace static S3 URL occurrences in loaded stylesheets at runtime with the
// environment-supplied AWS assets root. This keeps existing SCSS/CSS files
// unchanged but ensures any url(...) references using the old static URL are
// updated to the value provided in REACT_APP_AWS_ASSETS_ROOT_URL when the
// app runs in the browser.
const _AWS_STATIC_TARGET = 'https://master-vserve.s3.ap-south-1.amazonaws.com/';
const _AWS_ROOT = process.env.REACT_APP_AWS_ASSETS_ROOT_URL || '';
function replaceStaticAwsUrlsInStylesheets() {
    if (!_AWS_ROOT) return;
    // Delay slightly to allow stylesheets to be parsed
    setTimeout(() => {
        for (const sheet of Array.from(document.styleSheets || [])) {
            try {
                const rules = sheet.cssRules || sheet.rules;
                if (!rules) continue;
                for (const rule of Array.from(rules)) {
                    if (!rule || !rule.style) continue;
                    for (const prop of Array.from(rule.style)) {
                        const val = rule.style.getPropertyValue(prop);
                        if (val && val.includes(_AWS_STATIC_TARGET)) {
                            rule.style.setProperty(
                                prop,
                                val.split(_AWS_STATIC_TARGET).join(_AWS_ROOT)
                            );
                        }
                    }
                }
            } catch (e) {
                // Some stylesheets (cross-origin) can't be accessed; ignore
            }
        }
    }, 100);
}
if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', replaceStaticAwsUrlsInStylesheets);
    } else {
        replaceStaticAwsUrlsInStylesheets();
    }
}

ReactGA.initialize('G-8JH41HEJKM');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Provider store={store}>
            <HotelContextProvider>
                <LanguageContextProvider>
                    <App />
                </LanguageContextProvider>
            </HotelContextProvider>
        </Provider>
    </BrowserRouter>
);

serviceWorker.register();
